import { useEffect, type ReactNode } from "react";

import { Box, CircularProgress } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";

import { ForcePasswordChangePage } from "@/pages/ForcePasswordChangePage";
import { useAuthStore } from "@/store/authStore";

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { accessToken, me, status, loadMe } = useAuthStore();

  useEffect(() => {
    if (accessToken && !me && status !== "authenticating") {
      void loadMe();
    }
  }, [accessToken, me, status, loadMe]);

  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!me) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100dvh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // A temporary password grants nothing: the API refuses every permission-gated
  // endpoint, so rendering the app would just show errors everywhere.
  if (me.must_change_password) {
    return <ForcePasswordChangePage />;
  }

  return <>{children}</>;
}
